<div [@overlayAnimation]="visible" (@overlayAnimation.start)="onOverlayAnimationStart($event)" (swipedown)="swipe($event.type)" *ngIf="visible"
     class="overlay" (click)="onClose()"></div>
<div *ngIf="visible" [@slidePopup]="AnimationSortListScrollbar" (@slidePopup.done)="onSortListScrollbar($event)"
     (swipedown)="swipe($event.type)" id="wrapper-sort">
  <div class="wrapper-scrollbar-header" [textContent]="'مرتب سازی'"></div>
  <div class="wrapper-Scrollbar-body">
    <ul>
      <ng-template ngFor [ngForOf]="sortList" let-item let-i="index">
        <li class="Scrollbar-items" (click)="selected(i, item)" [class.active]="sortSelectIndex === i">
          <div class="title-Scrollbar-items">
            <span class="item" [textContent]="item.title"></span>
          </div>
        </li>
      </ng-template>
    </ul>
  </div>
</div>
